/**
 * Catalog Constants
 */
export const CATALOGS_APP_URL = '/catalogs';
export const CATALOG_DATA_TYPE = 'user';
export const CATALOG_NAME = 'Catalog';
export const CATALOGS_NAME = `Catalogs`;
export const ALL_CATALOGS_NAME = `All`;

/**
 * Catalog Collections Constants
 */
export const COLLECTION_NAME = 'Collection';
export const COLLECTIONS_NAME = 'Collections';
export const COLLECTION_TYPE_STATIC = 'static';
export const COLLECTION_TYPE_DYNAMIC = 'dynamic';
export const CATALOG_COLLECTIONS_APP_URL = '/catalogs/collections';
export const CATALOG_COLLECTION_HANDLEBARS = 'catalogCollection';
export const CATALOG_RECOMMENDATION_HANDLEBARS = 'productRecommendations';
export const CATALOG_COLLECTION_NAME = 'Catalog Collection';
export const CATALOG_COLLECTIONS_NAME = 'Catalog Collections';
export const CATALOG_COLLECTIONS_TITLE = 'Catalog collections';
export const BUILD_COLLECTION_TEXT = 'Build Collection';
export const CREATE_COLLECTION_TEXT = 'Create Collection';
export const CREATE_NEW_COLLECTION_TEXT = 'Create New Collection';
export const EDIT_COLLECTION_TEXT = 'Edit Collection';
export const NEW_COLLECTION_ID = '_new';
export const NEW_COLLECTION_NAME = 'New Catalog Collection';
export const PREVIEW_COLLECTION_TEXT = 'Preview Collection';
export const SAVE_COLLECTION_TEXT = 'Save Collection';
export const VIEW_COLLECTION_TEXT = 'View Collection';
export const VIEW_COLLECTIONS_TEXT = 'View Collections';

/**
 * Sidebar constants
 */
export const SIDEBAR_TABS = [
  {
    label: ALL_CATALOGS_NAME,
    to: CATALOGS_APP_URL,
    value: CATALOGS_NAME,
  },
  {
    label: COLLECTIONS_NAME,
    to: CATALOG_COLLECTIONS_APP_URL,
    value: COLLECTIONS_NAME,
  },
];

/* Tooltip Text for RBAC Permissions Enforced in Catalogs */
export const MISSING_MANAGE_CATALOGS_PERMISSION =
  'You do not have permission to manage catalogs. A project administrator can change this.';
export const MISSING_USER_PROFILES_DATA_PERIMISSIONS =
  'You do not have permissions to manage user profiles and data. A team administrator can change this.';

export const COLLECTIONS_HANDLEBARS_HELP_DOC_URL =
  'https://support.iterable.com/hc/en-us/articles/360033215032-Using-Catalogs-Collections-in-Messages-';
